// 创建文件zh.js
const zh = {
  test: '你好',
  language: {
    privacy: "隱私條款",
    service: "服務政策",
    manage: "管理規則",
    home: "首頁"
  },
}
export default zh;



// WEBPACK FOOTER //
// ./src/lang/zh.js